import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TrybeService } from '../../services/trybe.service';

@Component({
    selector: 'app-spa-package-items-modal',
    templateUrl: './spa-package-items-modal.component.html',
    styleUrls: ['./spa-package-items-modal.component.css']
})
export class SpaPackageItemsModalComponent implements OnInit {
    @Input() treatments = [];
    @Input() packageData = undefined;
    @Input() modalTreatmentsIdx = 0;

    @Output() complete = new EventEmitter();

    timeslotSelected = undefined;
    timeslotIdx = -1;
    treatmentIdx = -1;
    error = '';
    trybeBasket = undefined;
    titleString = '';


    constructor(
        private trybeService: TrybeService,
    ) { }

    ngOnInit(): void {
        console.log(this.treatments);

        const date = new Date(this.packageData.basketItem.date);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
        this.titleString = `${this.packageData.basketItem.guest.first_name} ${formattedDate}`;
        // this.titleString = `${this.packageData.basketItem.guest.first_name} ${new Date(this.packageData.basketItem.date).toISOString().slice(0, 10)}`
        console.log(this.titleString)
    }

    getTimes(idx) {
        if (this.treatments[idx].item_type === 'session') {
            this.getTimesPackage(idx);
            return;
        }
        this.clearTimeslots();
        this.treatmentIdx = idx;

        this.trybeService.getTimeSlots(this.treatments[idx].item_type, this.treatments[idx].id, this.packageData.date).subscribe(data => {
            this.treatments[idx].timeslots = data.data.data;
        })
    }

    getTimesPackage(idx) {

        this.clearTimeslots();
        this.treatmentIdx = idx;

        this.trybeService.getPackageTimeSlots(this.treatments[idx].item_type, this.packageData.basketItem.offering_id, this.treatments[idx].parentId, this.packageData.date).subscribe(data => {
            this.treatments[idx].timeslots = data.data.data[0].slots;
        })

    }

    selectSlot(ts, idx) {
        this.timeslotSelected = ts;
        this.timeslotIdx = idx;
        // this.time
    }
    confirmSlot() {
        const data = {
            choice_id: this.packageData.basketItem.option_budgets[1].choice_id,
            option_id: this.treatments[this.treatmentIdx].id,
            time: this.treatments[this.treatmentIdx].timeslots[this.timeslotIdx].start_time,
            duration: this.treatments[this.treatmentIdx].offering.duration,
            item_configuration: {
                choice_id: this.packageData.basketItem.option_budgets[1].choice_id,
                option_id: this.treatments[this.treatmentIdx].id,
                time: this.treatments[this.treatmentIdx].timeslots[this.timeslotIdx].start_time,
                duration: this.treatments[this.treatmentIdx].offering.duration,
                option_ids: []
            },
            basketItemId: this.packageData.basketItemId,
            basket_id: null
        }

        if (this.treatments[this.treatmentIdx].item_type === 'session') {
            data.choice_id = this.treatments[this.treatmentIdx].parentId;
            data.item_configuration.choice_id = this.treatments[this.treatmentIdx].parentId;
        }

        this.trybeService.basketAddSpaPackageItemOption(this.packageData.basketId, this.packageData.basketItemId, data, this.treatments[this.treatmentIdx].timeslots[this.timeslotIdx].start_time).subscribe(data => {
            if (data.data.error) {

                this.error = data.data.message;
                // this.basket = undefined;
            } else {
                this.trybeBasket = data.data.data;
                // this.basket = data.data.data;
                // this.processing = false;
                // this.itemAdded.emit(this.basket);
                this.confirm()
            }
            this.timeslotSelected = undefined;
        })
    }



    clearTimeslots() {
        this.timeslotSelected = undefined;
        this.timeslotIdx = -1;
        this.treatmentIdx = -1;

        this.treatments.forEach(t => {
            t.timeslots = []
        })
    }
    confirm() {
        this.complete.emit({ action: true, trybeBasket: this.trybeBasket });
    }
    close() {
        this.complete.emit({ action: false });
    }


}
